import { useEffect, useState } from "react";
import { BellIcon } from "@heroicons/react/24/solid";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  mainSelectedTab,
  notifTabIndex,
} from "../../CarrierAgreementMgmt/atoms";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { recordIdToShowInTS } from "../../CarrierAgreementMgmt/OfficeHierarchy/atoms/atoms";
import ModuleTabs, { UtilitiesTabNotif } from "./ModuleTabs";
import { NavBarItems } from "../../NavBar/NavBarItems";
import { isFromRediInvoice } from "../../CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/atoms/atoms";
import { FromNotifEmp } from "../../CarrierAgreementMgmt/Employees/Confie/atoms/atoms";

const RecentActivity = () => {
  const [recentActivityData, setRecentActivityData] = useState([]);
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);
  const [, setSelectedIndex] = useRecoilState(notifTabIndex);
  const [, setTabsIndex] = useRecoilState(mainSelectedTab);
  const [connection, setConnection] = useState(null);
  const history = useHistory();
  const [, setIsFromRedirection] = useRecoilState(isFromRediInvoice);
  const [, setIsFromRecent] = useRecoilState(FromNotifEmp);
  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_BASEURL}/hubs/notification`)
      .withAutomaticReconnect()
      .build();
    if (connect) {
      setConnection(connect);
    }
  }, []);

  useEffect(() => {
    if (connection) {
      connection.start().then(() => {
        connection.send("GetRecentActivities", user.emailAddress);
        connection.on("RecentActivities", (res) => {
          setRecentActivityData(res);
        });

        connection.on("NewNotification", (userName) => {
          connection.send("GetRecentActivities", user.emailAddress);
        });
      });
    }
  }, [connection]);

  const setRecordToShow = useSetRecoilState(recordIdToShowInTS);
  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-sm text-tertiary font-semibold">Recent Activity</h1>

        <div className="grid justify-items-end">
          <button
            onClick={() => {
              history.push("/notifications");
            }}
            className="hover:scale-90 bg-secondary flex h-6 sm:h-4 sm:w-20 sm:py-2 
            text-white xl:h-6 xl:w-24 lg:px-1 lg:py-2 hover:bg-quinary hover:border-quinary
            flex-row shadow-md items-center justify-around text-xxs border rounded-full px-4 "
          >
            View All
          </button>
        </div>
      </div>
      <div className="text-xxs">
        {recentActivityData.map((item, index) => {
          const urlPath = {
            pathname: item.route,
            state: {
              recordId: item.recordId,
              moduleName: item.moduleName,
              subModuleName: item.subModuleName,
            },
          };
          const isDeactivateDA =
            item.moduleName?.toLowerCase() === "digital assets" &&
            item.message?.toLowerCase().includes("deactivated");

          return (
            <div
              key={index}
              onClick={() => {
                if (isDeactivateDA) return;
                const moduleTabs = ModuleTabs(item.route);
                const utilitiesNotifTab = UtilitiesTabNotif(item.route);
                let userTabs = [];
                [...moduleTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                const navBarIndex = NavBarItems.findIndex((x) =>
                  x.path?.toLowerCase()?.includes(item.route?.toLowerCase())
                );
                if (item.route?.toLowerCase().includes("utilitiestab")) {
                  const utilitiesTabIndex = utilitiesNotifTab.findIndex((x) =>
                    x.to?.toLowerCase()?.includes(item.route?.toLowerCase())
                  );
                  setTabsIndex(navBarIndex);
                  setSelectedIndex(utilitiesTabIndex);
                }
                setSelectedIndex(navBarIndex);
                history.push(urlPath);

                if (item.moduleName === "Vendor") {
                  window.location.reload();
                }

                if (item.moduleName === "Office Hierarchy") {
                  setRecordToShow(item.recordId);
                }
                if (item.moduleName === "Vendor Invoice") {
                  setIsFromRedirection(true);
                }
                if (item.moduleName === "Employee") {
                  setIsFromRecent(true);
                }
              }}
              className={`cursor-pointer ${
                isDeactivateDA ? "pointer-events-none opacity-50" : ""
              }`}
            >
              <div className="my-2 p-2 border border-gray-50 bg-white items-center shadow rounded-lg flex flex-auto justify-start gap-2 group hover:bg-secondary">
                <div className="">
                  <BellIcon
                    className={
                      "h-6 w-6 p-1 bg-secondary rounded-md group-hover:bg-white" +
                      (item.isRecentAdded ? "temporary-bounce" : "") +
                      " text-white group-hover:text-secondary"
                    }
                  />
                </div>
                <div className="flex flex-col">
                  <div className="text-gray-800 group-hover:text-white">
                    <p className="font-bold inline-block">{item.fullName}</p>{" "}
                    {item.message} on{" "}
                    <p className="font-bold inline-block">{item.moduleName}</p>{" "}
                    <p className="font-bold inline-block">
                      {item.subModuleName.split("_").join(" ")}
                    </p>{" "}
                    <p className="inline-block">module</p>
                  </div>
                  <div className="text-xs3 text-gray-600 group-hover:text-white">
                    {new Date(item.createdOn).toLocaleString() + ""}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivity;
